// extracted by mini-css-extract-plugin
export var BLUE = "Button-module--BLUE--u6yjy";
export var WHITE = "Button-module--WHITE--jTwf3";
export var button = "Button-module--button--sRE36";